import type { RequestFn } from '../client';

export class Cards {
  constructor(private readonly request: RequestFn) {}

  /** Create a card. `POST /cards/create` */
  async create(params: Record<string, unknown>): Promise<Record<string, unknown>> {
    return this.request('POST', '/cards/create', { body: params });
  }

  /** Update a card. `POST /cards/update` */
  async update(params: Record<string, unknown>): Promise<Record<string, unknown>> {
    return this.request('POST', '/cards/update', { body: params });
  }

  /** Retrieve card info by BIN. `GET /cards/{bin}` */
  async retrieve(bin: string): Promise<Record<string, unknown>> {
    return this.request('GET', `/cards/${encodeURIComponent(bin)}`);
  }
}
